import React from 'react';
//import PropTypes from 'prop-types';
import {
  Label,
} from 'reactstrap';
import Services from './services';
import _ from 'lodash';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';

const JegyArForm = props => {
  const {
    formTeremkiosztasKod,
    formJegy,
    formJegyarKategoria,
    formJegyar,
    handleChangeInput,
    handleSelectInputChange,
    jegySWExists,
    penznemId
  } = props;

  const loadJegyekOptions = (input, callback) => {
    Services.listJegyek(null, penznemId, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( j => j.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadJegyArKategoriOptions = (input, callback) => {
    Services.listJegyArKategoriak(formTeremkiosztasKod, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( jk => jk.cod.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const renderForm = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-4" style={{paddingRight: '2px'}}>
            <SelectField
              variant='async'
              label='Jegy:'
              name="formJegy"
              id="formJegy"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => handleSelectInputChange(v, 'formJegy')}
              loadOptions={_.debounce(loadJegyekOptions, 1000)}
              getOptionLabel={option => option.nev + ' (' + option.azonosito + ')'}
              getOptionValue={option => option.id}
              value={formJegy}
              cache={false}
              isLoading={false}
              isClearable
              defaultOptions
              required
            />
          </div>
          <div className="col-md-4">
            {jegySWExists ?(
              <React.Fragment>
                <SelectField
                  label='Árkategória:'
                  variant='async'
                  name="formJegyarKategoria"
                  id="formJegyarKategoria"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => handleSelectInputChange(v, 'formJegyarKategoria')}
                  loadOptions={_.debounce(loadJegyArKategoriOptions, 1000)}
                  getOptionLabel={option => option.cod}
                  getOptionValue={option => option.cod}
                  value={formJegyarKategoria}
                  cache={false}
                  isLoading={false}
                  isClearable
                  defaultOptions
                  required
                />
              </React.Fragment>
            ):
                <RFField
                  label={'Árkategória: '}
                  name={"formJegyarKategoria"}
                  id={"formJegyarKategoria"}
                  type="text"
                  value={formJegyarKategoria}
                  onChange={handleChangeInput}
                />
            }
          </div>
          <div className="col-md-4">
              <RFField
                label={'Ár: *'}
                name={"formJegyar"}
                id={"formJegyar"}
                type="text"
                value={formJegyar}
                onChange={handleChangeInput}
                required
              />
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderForm()}
      </div>
    </div>
  );
}

export default JegyArForm;
